/*
 * Copyright (c) 2019-2026  Apricad LLC. All Rights Reserved.
 */

import * as pdfjsLib from "pdfjs-dist-es5/build/pdf";
import workerSrc from "pdfjs-dist-es5/build/pdf.worker.js";

export class PdfLib {
  pdfjsLib: any;
  pdfDoc: any;

  constructor() {
    this.pdfjsLib = pdfjsLib;
    this.pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
  }

  // set PDF document, return the page width and count
  async setPdfDoc(pdfContent: any) {
    const loadingTask = this.pdfjsLib.getDocument({
      data: atob(pdfContent.licensedDoc),
    });

    const pdfDoc_ = await loadingTask.promise;
    this.pdfDoc = pdfDoc_;

    const page = await pdfDoc_.getPage(1);
    const viewport = page.getViewport({ scale: 1 });

    return {
      pageWidth: viewport.width,
      pageHeight: viewport.height,
      pageCount: pdfDoc_.numPages,
    };
  }

  getDoc() {
    return this.pdfDoc;
  }
}
